import {Routes} from '@angular/router';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import {PlatformToolContainerComponent} from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';

export const platformRoutes: Routes = [

  {
    path: 'share',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'share/:magicLinkId',
    component: PlatformToolContainerComponent
  },
];
